import axios from "axios";
import { cacheRequest, makeRequest, networkGlobals } from "./networkUtils";
import { AttributeJSON, AttrResponseType } from "models/profile/Attribute.old";
import { getBucket } from "./networkUtils";
import { formtHeight, groupBy } from "./globalsUtils";
import { HIDDEN_ATTRIBUTES } from "./matchmakerUtils";
import { Introduction } from "models/introduction/Introduction";
import { ProfileAttributePolicy, Profile } from "models/profile/Profile";
import { Attribute, MatchType } from "models/profile/Attribute";
import { BioPrefRelation } from "models/batch/BioPrefRelation";
import { ResponseSetting, ResponseType, VisSetting } from "models/batch/Question";
import form from "layouts/pages/users/new-user/schemas/form";

// let profileAttributes: { [key: string]: AttributeJSON[] } = {};
// export const loadAttributes = async (): Promise<AttributeJSON[]> => {
//   const brand = networkGlobals.brand.name.toLocaleLowerCase();
//   const key = `${brand}-${getBucket()}`;
//   if (!profileAttributes[key]?.length) {
//     profileAttributes[key] = await axios
//       .get(
//         `https://${getBucket()}.s3.amazonaws.com/public/generated/${brand}/1.0.1/profile_attr_en.json`
//       )
//       .then((res) => res.data);
//   }
//   return profileAttributes[key].map((attr) => Object.assign(new AttributeJSON(), attr));
// };

export const getAttributes = (withQuestions: boolean = false): Promise<Attribute[]> => {
  return makeRequest(`attributes?withQuestions=${withQuestions}`)
    .then((res) => res.map((attr) => Object.assign(new Attribute(), attr)))
    .catch((err) => {
      ;
      return [];
    });
};

export const addAttributeDO = (attribute: Attribute) => {
  return makeRequest(`attributes`, {
    method: "POST",
    body: attribute,
  });
};

export const updateAttributeDO = (attribute: Attribute) => {
  return cacheRequest(`attributes/${attribute.id}`, {
    method: "PUT",
    body: attribute,
  });
};

export const publishAttributes = () => {
  return makeRequest(`attributes/publish`, {
    method: "POST",
  });
};

export const saveAttributeOrder = (attributeIds: string[]) => {
  return makeRequest(`attributes/reorder`, {
    method: "PUT",
    body: { attributeIds },
  });
};

export const getAttribute = (id: string): Promise<Attribute> => {
  return makeRequest(`attributes/${id}`);
};

export const getBioPrefRelations = (): Promise<BioPrefRelation[]> => {
  return makeRequest(`attributes/relations`);
};

export const updateBioPrefRelation = (relation: BioPrefRelation) => {
  return makeRequest(`attributes/${relation.bioAttrId}/relations/${relation.id}`, {
    method: "PUT",
    body: relation,
  });
};

export const createBioPrefRelation = (relation: BioPrefRelation) => {
  return makeRequest(`attributes/${relation.bioAttrId}/relations`, {
    method: "POST",
    body: relation,
  });
};

// export const getBioPrefRelationsOfname = (name: string): Promise<BioPrefRelation[]> => {
//   return makeRequest(`oldattributes/${name}/relations`);
// };

// export const updatePrevalidation = (preValidation, bcid) => {
//   return makeRequest(`oldattributes/batchContents/${bcid}/preValidation`, {
//     method: "POST",
//     body: preValidation,
//   });
// };

export const getBioPrefRelationsByAttr = (attrName) =>
  makeRequest(`attributes/${attrName}/relations`);

export const getAutocompleteAnswers = (id) => {
  return makeRequest(`attributes/${id}/autocompleteAnswers`);
};

export const updateAutocompleteAnswers = (answer) => {
  return makeRequest(`attributes/autocompleteAnswers`, { body: answer, method: "PUT" });
};

// export const updateBioPrefRelations = (attrName, relations) => {
//   return makeRequest(`oldattributes/${attrName}/relations`, {
//     method: "POST",
//     body: relations,
//   })
//     .then((res) => res.data)
//     .catch((err) => {
//       ;
//       return [];
//     });
// };

export const deleteBioPrefRelation = (relation: BioPrefRelation) => {
  return makeRequest(`attributes/${relation.bioAttrId}/relations/${relation.id}`, {
    method: "DELETE",
  });
};

const findPrefFromBio = (
  attrs: Attribute[],
  bio: string,
  relations: BioPrefRelation[]
): Attribute[] => {
  const prefNames = relations.filter((r) => r.bioAttrId == bio).map((r) => r.prefAttrId);
  const prefAttribute = attrs.filter((a) => prefNames.includes(a.name));
  return prefAttribute;
};

export const findBioFromPref = (
  attrs: Attribute[],
  pref: string,
  relations: BioPrefRelation[]
): Attribute[] => {
  const relation = relations.find((r) => r.prefAttrId == pref);
  const bioAttribute = attrs.filter((a) => a.name == relation?.bioAttrId);
  return bioAttribute;
};

export const isAttributesMatch = (
  bio: Attribute,
  pref: Attribute,
  bioValue,
  prefValue,
  relations: BioPrefRelation[]
): MatchType => {
  if (!bioValue?.length || !prefValue?.length) return MatchType.Empty;

  if (bio.responseType == ResponseType.Scale) {
    return prefValue[0] <= bioValue[0] && prefValue[1] >= bioValue[0]
      ? MatchType.Exact
      : MatchType.NoMatch;
  }

  if (![ResponseType.SingleChoice, ResponseType.MultipleChoice].includes(bio.responseType)) {
    return MatchType.Empty;
  }
  const bioRelations = relations.filter(
    (r) => r.bioAttrId == bio.name && r.prefAttrId == pref.name
  );

  const bioResponses = bio.responses?.filter((r) => bioValue.includes(r.txtId));
  const prefResponses = pref.responses?.filter((r) => prefValue.includes(r.txtId));

  if (bioResponses?.some((bioResponse) => bioResponse.type == AttrResponseType.RatherNotSay)) {
    return MatchType.Empty;
  }

  const matches = bioRelations.filter((bpr) => {
    const prefResponse = prefResponses.find((pref) => bpr.prefResponseId == pref.txtId);

    return (
      prefResponse &&
      (prefResponse.type == AttrResponseType.OpenToAll ||
        bioValue.some((v) => bpr.bioResponseId == v))
    );
  });

  if (!matches?.length) return MatchType.NoMatch;

  return matches?.some((match) => match.score > 5)
    ? MatchType.Exact : MatchType.Partial
};

export const visibiltyOptions = {
  PUBLIC: {
    label: "Visible For Partners & SME",
    value: 1,
  },
  SME_VISIBLE: {
    label: "Visible For SME",
    value: 5,
  },
  PRIVATE: {
    label: "Visible Only For Me",
    value: 3,
  },
  HIDDEN: {
    label: "Hidden From All (Techincal attribute)",
    value: 4,
  },
};

export const getIntroAttrArray = (
  attributes: Attribute[],
  relations: BioPrefRelation[],
  request: Introduction,
  isShidduch: boolean
): AttributeBioPref[] => {
  const groupped = groupBy(attributes, (x: Attribute) => x.attributeGroup);
  return (
    (groupped["bio"] || [])
      .filter((attr) => !HIDDEN_ATTRIBUTES.includes(attr.name))
      .filter((attr: Attribute) => !attr.isSensitive)
      // .filter((attr) => !(request.initiatorProfile?.attributesPolicy?.[attr.name] == AttributePolicy.autofilled ||
      //                     request.responderProfile?.attributesPolicy?.[attr.name] == AttributePolicy.autofilled))
      .filter(
        (attr: Attribute) =>
          !isShidduch ||
          [visibiltyOptions.PUBLIC.value, visibiltyOptions.SME_VISIBLE.value].includes(
            attr.defaultPolicy
          )
      )
      .map((attr: Attribute) => {
        const initiatorBioPref = getProfileBioPref(
          request.initiatorProfile,
          attr,
          attributes,
          relations
        );
        const responderBioPref = getProfileBioPref(
          request.responderProfile,
          attr,
          attributes,
          relations
        );
        let initiatorMatch: MatchType = MatchType.NoMatch;
        let responderMatch: MatchType = MatchType.NoMatch;

        if (
          !initiatorBioPref?.initiatorBio &&
          !responderBioPref?.initiatorBio &&
          !initiatorBioPref?.initiatorPrefernce &&
          !responderBioPref?.initiatorPrefernce
        ) {
          return null;
        }

        if (initiatorBioPref && responderBioPref) {
          initiatorMatch = isAttributesMatch(
            attr,
            initiatorBioPref.prefAttribute,
            request.initiatorProfile?.attributesValues[attr.name],
            request.responderProfile?.attributesValues[initiatorBioPref.prefAttribute?.name],
            relations
          );

          responderMatch = isAttributesMatch(
            attr,
            responderBioPref.prefAttribute,
            request.responderProfile?.attributesValues[attr.name],
            request.initiatorProfile?.attributesValues[responderBioPref.prefAttribute?.name],
            relations
          );
        }

        return {
          ...(initiatorBioPref || responderBioPref),
          initiatorBio: initiatorBioPref?.initiatorBio,
          responderBio: responderBioPref?.initiatorBio,
          initiatorPrefernce: initiatorBioPref?.initiatorPrefernce,
          responderPrefernce: responderBioPref?.initiatorPrefernce,
          initiatorMatch,
          responderMatch,
        } as AttributeBioPref;
      })
      .filter((r) => r)
      .sort((a, b) => a.bioName?.localeCompare(b.bioName))
  );
};

export const getAttrArray = (
  attributes: Attribute[],
  relations: BioPrefRelation[],
  profile: Profile
): AttributeBioPref[] => {
  const groupped = groupBy(attributes, (x: Attribute) => x.attributeGroup);
  return (
    (groupped["bio"] || [])
      .filter((attr: Attribute) => !HIDDEN_ATTRIBUTES.includes(attr.name) || attr.name == "height")
      .filter((attr: Attribute) => !attr.isSensitive)
      // .filter((attr) => profile.attributesPolicy?.[attr.name] != AttributePolicy.autofilled)
      .map((attr: Attribute) => getProfileBioPref(profile, attr, groupped["pref"], relations))
      .filter((r) => r?.initiatorBio || r?.initiatorPrefernce)
      .sort((a, b) => a.bioName?.localeCompare(b.bioName))
  );
};

const getProfileBioPref = (
  profile: Profile,
  attr: Attribute,
  prefs: Attribute[],
  relations: BioPrefRelation[]
): AttributeBioPref | null => {
  if (!profile.attributesValues) return null;
  const initiatorBio = profile?.attributesValues[attr.name]
    ?.map((x) => (typeof x === "string" || !x ? x : JSON.stringify(x)))
    .join(",");

  let initiatorBioTxt = attr.responses
    ?.filter((r) => profile.attributesValues[attr.name]?.includes(r.txtId))
    ?.map((r) => r.txt)
    .join(", ");

  const prefAttributes = findPrefFromBio(prefs, attr.name, relations);

  let initiatorPrefTxt = prefAttributes
    .map(
      (prefAttribute) =>
        prefAttribute?.responses
          ?.filter((r) => profile?.attributesValues[prefAttribute?.name]?.includes(r.txtId))
          ?.map((r) =>
            ["Yes", "No"].includes(r.txt)
              ? "<strong>" + prefAttribute?.txt + ":</strong> " + r.txt + "</br>"
              : r.txt
          )
          .join(", ") ||
        profile?.attributesValues[prefAttribute?.name]
          ?.map((x) => (typeof x === "string" ? x : JSON.stringify(x)))
          .join(", ")
    )
    .join("\n");

  let responseType = attr.responseType;

  if (attr.name == "height") {
    initiatorBioTxt = formtHeight(parseInt(initiatorBio));
    initiatorPrefTxt = prefAttributes
      ?.map((p) => profile.attributesValues[p.name]?.map(formtHeight))
      .join(", ");
    responseType = ResponseType.Text;
  }
  return {
    id:
      attr.editingQuestionId?.toString() ||
      initiatorBio?.toString() ||
      initiatorPrefTxt + Math.random(),
    name: attr.name,
    bioName: attr.txt || attr.name,
    initiatorBio: initiatorBioTxt || initiatorBio?.toString(),
    initiatorPrefernce: initiatorPrefTxt,
    responseType,
    rangeMax: attr.questions?.[0]?.rangeMax,
    rangeMin: attr.questions?.[0]?.rangeMin,
    responseSettings: attr.questions?.[0]?.responseSettings,
    batchId: attr.relatedBatchId,
    visSettings: attr.questions?.[0]?.visSettings,
    prefAttribute: prefAttributes[0],
    isDealBreaker: prefAttributes[0]?.questions?.[0]?.isDealBreaker,
    canEdit: !attr.userEditable,
  };
};

export interface AttributeBioPref {
  id?: string;
  name: string;
  bioName?: string;
  initiatorBio?: string;
  responderBio?: string;
  initiatorPrefernce?: string;
  responderPrefernce?: string;
  responseType: ResponseType;
  rangeMax?: number;
  rangeMin?: number;
  responseSettings?: ResponseSetting;
  batchId: number;
  visSettings?: VisSetting;
  prefAttribute: Attribute;
  isDealBreaker: number;
  initiatorMatch?: MatchType;
  responderMatch?: MatchType;
  canEdit?: boolean;
  reportedBio?: Date;
  reportedPref?: Date;
}
